export default __webpack_public_path__ + "static/media/gazprom_logo.ebabc804.png";